import { FunctionComponent } from 'react';
import Icon from 'components/Shared/Icon';
import css from 'styled-jsx/css';
import arrowLeft from './prev-slide-arrow.svg';
import arrowRight from './next-slide-arrow.svg';

export enum Direction {
  previous = 'PREVIOUS',
  next = 'NEXT',
}

interface SlideArrowProps {
  onClick?: () => void;
  logEvent: () => void;
  direction: Direction;
}

const iconCSS = css.resolve`
  .icon-right-margin {
    margin-right: 0;
  }
`;

const SlideArrow: FunctionComponent<SlideArrowProps> = ({
  onClick,
  logEvent,
  direction,
}: SlideArrowProps) => {
  function handleClick(): void {
    logEvent();
    if (onClick) {
      onClick();
    }
  }

  return (
    <div>
      <button
        className="slideshow-slide-arrow-button"
        onClick={handleClick}
        data-testid="slide-arrow"
      >
        <Icon
          className={`icon-right-margin ${iconCSS.className}`}
          image={direction === Direction.previous ? arrowLeft : arrowRight}
        />
      </button>
      <style jsx>{`
        .slideshow-slide-arrow-button {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          z-index: 1;
          top: 20%;
          height: 120px;
          width: 47.9px;
          background-repeat: no-repeat;
          background-color: rgba(0, 0, 0, 0.6);
          border: 0;
          cursor: pointer;
          ${direction === Direction.previous ? 'left: 0;' : 'right: 0;'}
        }
      `}</style>
      {iconCSS.styles}
    </div>
  );
};

export default SlideArrow;
